/* eslint-disable quotes */
/* eslint-disable max-len */
export const langFile = {
  common: {
    close: 'Tancar',
    day: 'dia',
    euro: '€',
    included: 'Inclosos',
    noResults: 'Sense resultats',
    standardError:
      'Ho sentim, hi ha hagut un error inesperat. Torna a provar-ho més tard o contacta amb atenció a client.',
    vatIncluded: 'IVA INCLÒS',
    terminalIn: 'Terminal d\'entrada:',
    terminalOut: 'Terminal de sortida:',
    new: 'Nou',
  },
  confirmationStep: {
    return: 'Tornar',
    psd2Title: 'Activa la teva targeta per poder usar-la',
    psd2Body:
      'El teu banc sol·licita validar la targeta ****{{cardNumber}} per poder-la utilitzar quan surtis. Només cal fer-ho una vegada i podràs utilitzar-la a totes les teves estades amb nosaltres.',
    psd2Button: 'Validar targeta',

    instagramTitle: 'Segueix-nos a Instagram',
    instagramBody:
      "Els millors continguts sobre aparca&go i tot el que cal saber sobre el teu viatge. A més a més gaudeix d'ofertes exclusives per a seguidors!",
    instagramButton: 'Seguir @aparcandgo_es',
    checkCarsevices: 'Veure pressupost Car Service',
    willSendEmail:
      "Rebràs un correu electrònic amb totes les instruccions d'arribada i de tornada.",
    isFastlane: 'Tens el carril ràpid activat!',
    addServicesQuestion: 'Vols afegir serveis a la reserva?',
    addServicesText2: 'Encara ets a temps.',
    addServicesClick: 'Clica aquí!',
    reservationNumber: 'Nombre de reserva',
    additionalInfo: 'Informació addicional',
    addServices: 'Afegir serveis',
    addServicesBody:
      "Encara ets a temps d'aprofitar el viatge i posar a punt el teu cotxe.",
    agencyReservation: "Podeu consultar la reserva a la seva Àrea d'Agència.",
    appleWallet: 'Apple Wallet',
    cancelReservation: 'Cancel·lar Reserva',
    carServiceInstructions: 'Car Service',
    checkReservation: 'Veure Reserva',
    validateChallengeText: 'Pots agilitzar la sortida validant la targeta.',
    validateChallengeButton: 'Validar ara',
    confirmationEmailSended:
      "T'estem enviant un correu electrònic de confirmació a",
    fastLaneWashWarning:
      "<b>Has reservat un rentat.</b> Entra al parking per taquilla per tal que el nostre personal t'indiqui la zona on has d'aparcar i deixar les claus del teu vehicle.",
    covidTitle: 'Mesures Covid-19',
    covidBody:
      'Seguim totes les mesures de seguretat perquè viatgis amb tota tranquil·litat.',
    covidLink: '/ca/info-covid-19',
    downloadApp: "Descarrega't la nostra App",
    downloadAppText:
      "Gestiona la teva reserva ràpidament a través de l'App d'aparca&go",
    downloadReservation: 'Descarregar Reserva',
    editReservation: 'Modificar Reserva',
    fastLaneBody:
      'Entra i surt del nostre pàrquing a través del carril ràpid amb el codi de barres que rebràs al teu email de confirmació.',
    fastLaneTitle: 'Encara pots anar més ràpid!',
    fastLaneLink: '/ca/serveis/parquing/carril-rapid',
    gracePeriodTitle: 'Avís sobre el preu de la teva reserva',
    gracePeriodBody:
      'Recorda que tens fins les {{hours}}h del {{day}} per recollir el teu vehicle sense que es produeixin canvis en el preu de la teva reserva. Bon viatge! (<a title="+info tarifes" href="https://www.aparcandgo.com/ca/aviso-legal">+info tarifes</a>)',
    ifNotRegistered:
      "Reserves sense estar registrat/da? T'estàs perdent un munt de dies de pàrquing gratis.<b (click)='registerInConfirmation()'><u>Registra't ara</u></b> i comença a acumular punts a aparca&go.",
    ifSporadicWithRegisteredEmail:
      'Amb aquesta reserva podeu acumular {{newPoints}} euros. <br> Vincula la teva reserva al teu compte de client per seguir acumulant punts i aprofitant els avantatges de la teva <u (click)="navigateToUserPanel()">àrea on-line.</u>',
    linkReservationCTA: 'Vincular reserva',
    ifRegisteredPoints: 'Amb aquesta estada acumularàs {{newPoints}} euros',
    ifRegisteredPointsUser: ' en el teu saldo actual de {{userPoints}}.',
    instructions: 'Instruccions',
    itv: 'ITV',
    maintenance: 'Manteniment',
    manageReservation: 'Gestiona la teva reserva',
    moreInfo: 'Més informació',
    others: 'Altres',
    paymentBody: "Paga l'import d'aquesta reserva directament al pàrquing.",
    paymentBodyExpress:
      "Pots pagar en metàl·lic, amb targeta o mitjançant l'App.",
    paymentTitleExpress:
      'Paga la teva estada al nostre pàrquing en passar per taquilla abans de sortir.',
    paymentBodyPremium: "Pots pagar amb targeta de crèdit o mitjançant l'App.",
    paymentTitlePremium:
      "Paga el teu servei quan t'entreguem de nou el teu vehicle.",
    paymentTitleUrban:
      "Paga la teva estada al {{urbanParkingName}} i recull les claus del teu vehicle a taquilla abans de sortir de l'aparcament.",
    paymentTitle:
      "El pagament s'efectuarà al pàrquing (Express i Estacions) o al moment de recollida a Premium.",
    reviews: 'Revisions',
    thanks: 'Gràcies per la teva reserva!',
    updated: 'La teva reserva ha estat actualitzada!',
    wash: 'Rentats',
    keysNeededReminder:
      "Recorda que la reserva requereix l'entrega de la clau al nostre personal.",
    CTAForm2Title: 'Estalvia temps i esforços!',
    CTAForm2Body:
      "Afegeix serveis a la teva reserva i aprofita l'ocasió per posar a punt el teu cotxe: rentat de cotxe, proveïment de combustible o recàrrega, inflat de rodes, canvi de filtres i olis, passar la ITV, etc. o fins i tot fer la revisió oficial del teu cotxe.",
    CTAForm2BodyShort:
      "Afegeix serveis a la teva reserva i aprofita l'ocasió per posar a punt el teu cotxe.",
    CTAForm2Click: 'Afegir serveis',
  },
  errorTailor: {
    email: 'Email no vàlid',
    maxLength: "No has d'introduir més de {{requiredLength}}",
    minLength: 'Ha de contenir {{requiredLength}} o més caràcters',
    required: 'És obligatori omplir el camp',
    requiredDni:
      "No és un document d'identificació vàlid. Assegura't que estàs afegint un número de DNI sense espais, guions ni punts en el cas que la teva raó social sigui un nom i cognoms (persona física) Ex: 11222333X. Assegura't que estàs afegint un NIF d'empresa sense espais, guions ni punts en el cas que la teva raó social sigui una societat (Jurídica) Ex: B11222333.",
    vatErrorFormatVies:
      "Assegura't que si estàs fora d'Espanya i dins de la CEE, afeixeixis el VAT number sense espais, guions, ni punts. Ex: PT111222333",
    requiredEmail: "T'enviarem aquí la teva confirmació",
    requiredPhone: 'Ens posarem en contacte amb tu en cas de necessitat',
    requiredSignPlate: 'Amb quin vehicle vens a aparcar',
    invalidNameDni: 'El NIF introduït és un DNI, introdueix nom i cognoms',
    invalidNameNie: 'El NIF introduït és un NIE, introdueix nom i cognoms',
  },
  homeModule: {
    homeForm: {
      email: 'Email',
      name: 'Nom',
      needInvoice: 'Necessito factura',
      phone: 'Telèfon',
      signPlate: 'Matrícula',
      surname: 'Cognoms',
      title: 'Dades de la reserva',
      travelForWork: 'Viatjo per feina',
    },
  },
  notFoundPage: {
    message: "No s'ha trobat la pàgina",
  },
  navTab: {
    availableServices: 'Serveis disponibles',
    confirmation: 'Confirmació',
    five: '5',
    four: '4',
    howToPark: 'Com vols aparcar',
    one: '1',
    summary: 'Resum',
    three: '3',
    travelerData: 'Informació del viatger',
    two: '2',
    whereAndWhen: 'On i quan',
  },
  productsStep: {
    bkgAenaDialog: {
      text1:
        "El descompte d'estalvi en comparació amb el pàrquing oficial està calculat usant la tarifa estàndard sense reserva.",
      text2:
        'Encara que monitorem aquests preus constantment, aquestes tarifes poden canviar sense avís previ. Si tens dubtes sobre el preu o descompte que estàs veient, no dubtis en <a href="/es/contacto-telefono-email">contactar</a>, i atendrem qualsevol dubte que tinguis.',
      title: 'Comparativa de preus',
    },
    bkgProductCard: {
      aena: 'AENA',
      freeCancellation: 'Cancel·lació gratuïta',
      minutes: 'min.',
      moreInfo: 'Més info +',
      payTheParking: 'Pagues al pàrquing',
      saving: 'estalvi',
      select: 'Escollir',
      highDemandMessage: 'Hi ha alta demanda per a les dates que busques!',
      almostOutMessage:
        'Queden molt poques places per a les dates que busques!',
      outOfStockMessage: 'Últimes places disponibles!',
      allTypePlacesOutMessage:
        "No disponible en aquestes dates! <br> <div> Per disfrutar d'aquest servei escull altre dates.<div>",
    },
    bkgTripInfoCruiserName: {
      cruiserName: 'Nom del Creuer',
      info: 'Per poder recollir-te, si us plau indica el nom del creuer',
      others: 'Altres',
    },
    bkgTripInfoDialog: {
      aboutYourTravel: 'Dades del teu viatge',
      continue: 'Continuar',
      alert:
        'Del {{startDay}} de juliol al {{endDay}} de setembre no poden accedir al parking vehicles de més de 5,5 metres',
    },
    bkgTripInfoExtras: {
      add: 'Afegir +',
      added: 'Inclòs!',
      externalPlace: 'Plaça exterior',
      improvePlace: "Tria el tipus de plaça d'aparcament",
      highDemandMessage: 'Hi ha alta demanda per a les dates que busques!',
      almostOutMessage:
        'Queden molt poques places per a les dates que busques!',
      outOfStockMessage: 'Esgotat',
      busClaim: 'Podràs aparcar just al costat de la parada de bus!',
    },
    bkgTripInfoPassengers: {
      passengersIn: "Passatgers d'anada",
      passengersOut: 'Passatgers de tornada',
      passengersTooltip:
        'Necessitem saber el nombre de passatgers per planejar el trànsit de passatgers i donar-te el millor servei. No hi ha cap cost afegit per passatger extra.',
      passengersTransfer: 'Quants passatgers cal traslladar?',
    },
    bkgTripInfoReturnFlight: {
      addReturnFlight:
        "Per poder recollir-te, si us plau indica'ns el teu número de vol de tornada",
      returnFlight: 'IB1234',
    },
    bkgProductsPage: {
      selectDeliverCar: 'Tria com aparcar',
      highDemandMessage: 'Hi ha alta demanda per a les dates que busques!',
      almostOutMessage:
        'Queden molt poques places per a les dates que busques!',
      outOfStockMessage:
        'No hi ha disponibilitat al pàrquing per a les dates seleccionades. Intenta reservar per a una altra data.',
    },
  },
  sharedModule: {
    bkgCookiesAdvice: {
      accept: 'Entesos',
      reject: 'Rebutjar',
      textHtml:
        'Aquesta web utilitza cookies pròpies i de tercers per a realitzar labors analítiques i obtenir estadístiques de l\'ús de la web realitzat pels usuaris. Pots configurar les cookies establertes en qualsevol moment i obtenir més informació sobre aquest tema en la <a href="/ca/politica-cookies" title="Política de cookies">Política de cookies</a>.',
    },
    bkgCustomTiresService: {
      added: 'Servei afegit correctament.',
      title: 'Canvi de pneumàtics',
      body:
        "Aprofita que el cotxe està aparcat per canviar els pneumàtics. T'enviarem un pressupost perquè ho acceptis abans d'arribar al pàrquing.",
    },
    bkgCustomServices: {
      added: 'Servei afegit correctament.',
      title: 'No trobes el servei que necessites?',
      body1: "No passa res, t'ajudem de totes maneres.",
      body2:
        "Posa't en contacte amb nosaltres i et donaren una solució a mida.",
      notes: 'Sol·licita els serveis que necessitis',
      terms:
        "A l'emplenar el present formulari, acceptant les condicions de servei, es procedirà a registrar la teva consulta. T'informem que, aparca&go S.L. com a responsable de l'arxiu, tractarà les dades amb l'única finalitat de gestionar la consulta.",
    },
    bkgHeader: {
      account: 'El teu compte',
      greeting: 'Hola',
      login: 'Accedeix',
      logout: 'Tancar sessió',
      reservation: 'Les teves reserves',
      businessMode: 'Canviar a perfil Empresa',
      individualMode: 'Canviar a perfil Particular',
      signUp: "Registra't",
    },
    bkgFeedbackDialog: {
      profileTitle: 'Perfil afegit correctament',
      profileBody: 'Ja pots utilitzar el perfil de facturació {{profile}}',
      registerTitle: 'Registre correcte',
      registerBody:
        "T'hem enviat un correu a {{email}} perquè puguis confirmar el teu email",
      servicesTitle: 'Servei afegit correctament',
      servicesBody:
        'Pots continuar afegint serveis a la teva reserva, o clicar al botó Continuar per finalitzar la reserva.',
      customServicesTitle: 'Servei a mida afegit!',
      customTiresServiceTitle: 'Servei de canvi de pneumàtics afegit!',
      customServicesBody:
        'Finalitza la teva reserva i ens posarem en contacte amb tu per informar de la disponibilitat i cost de el servei que ens has demanat.',
      vehicleTitle: 'Vehicle afegit',
      vehicleTitleEdit: 'Vehicle editat',
      vehicleBody:
        'Hem afegit el vehicle {{plate}} - {{model}} al teu perfil correctament',
      vehicleDangerTitle: 'Vehicle no trobat',
      vehicleDangerBody: 'Si us plau, selecciona la marca i model manualment',
    },
    bkgFooter: {
      privacyLink: '/ca/politica-privadesa',
      legalLink: '/ca/avis-legal',
      siteMapLink: '/ca/mapa-web',
      privacy: 'Privacitat',
      legal: 'Avís legal',
      siteMap: 'Mapa web',
      copyright: '© 2024 aparca&go S.L. Tots els drets reservats.',
    },
    bkgHourPicker: {
      titleStart: 'A quina hora vols entregar el cotxe?',
      titleEnd: 'A quina hora vols recollir el cotxe?',
      info:
        "<p>El nostre minibús llançadora (reserva Express) et deixarà a la porta de la terminal en 5 minuts, tot i així et recomanem arribar a l'aparcament amb temps suficient per aparcar amb tranquil·litat.</p> <p>Si prefereixes entregar el teu cotxe directament a la terminal (reserva Premium), selecciona l'hora exacta a la que tenies planejat arribar a l'aeroport. T'estarem esperant!</p>",
      infoShip:
        "<p>Tria la teva hora d'entrada: a les 8:00am, 9:15am, 10:30am, 12:30am o 12:30pm. Una vegada aparcat tindràs 30 minuts per agafar el nostre minibús gratuït que portarà directament a l'aparcament de la Terminal de Cruceros del Puerto.</p>",
    },

    bkgInfoSectionDialog: {
      addToMyBooking: 'Afegir servei',
      checkControls: 'Comprovació de {{ controlsLength }} punts de control',
      removeFromMyBooking: 'Treure de la meva reserva',
      select: 'Seleccionar',
      calculatePrice: 'Calcular preu',
      price: 'Preu',
      vat: 'Iva (21%)',
      totalPrice: 'TOTAL CAR SERVICE',
    },
    bkgAlternativeOfferDialog: {
      title: 'Places esgotades per a aquest producte',
      booking: 'Confirmar canvi',
      changesDatesOrProduct: 'Desitjo canviar de dates',
      infoTooltip: '{{description}}',
      newPrice: 'Nou preu: ',
    },
    bkgInitialBookingDataDialog: {
      anotherTerminal: 'Torno a una altra terminal',
      bookingBtn: 'Reservar',
      dateAndTime: 'Data i hora',
      entrance: 'Entrada',
      exit: 'Sortida',
      where: 'On?',
      parking: 'Pàrquing',
      selectParking: 'Selecciona aparcament',
      title: 'Seleccioneu aparcament',
      dates: 'Actualitza la reserva',
      datesBtn: 'Continuar',
      deliverCar: 'Com vols entregar el teu cotxe?',
      pickup: 'On necessites que et traslladem?',
      welcomeTitle: 'Tot el que necessita el teu cotxe mentre ets de viatge',
      welcomeBody:
        'Reserva la teva plaça de pàrquing, afegeix els serveis de taller que necessitis, i aparca de manera ràpida, còmoda i segura.',
    },
    bkgLoginDialog: {
      accountMessage: "Tens compte d'aparca&go?",
      bodyTitle: 'Accedeix al teu compte',
      continueRegistration: 'Continuar sense registrar-me',
      email: 'Email',
      facebookBtn: 'Facebook',
      forgetPassword: 'Recuperar contrasenya',
      googleBtn: 'Google',
      appleBtn: 'Apple',
      loginBtn: 'Accedir',
      password: 'Contrasenya',
      signUpFree: "Registra't gratis",
      title: 'Reserva encara més ràpid',
      individualCustomer: 'Particulars',
      agencies: 'Agencies',
      agencyTitle: "Accedeix al teu compte d'Agència",
      alias: 'Usuari',
    },
    bkgRecoveryPassDialog: {
      title: 'Restablir contrasenya',
      body:
        "Ingressa l'adreça de correu electrònic associada amb el teu compte i et farem arribar l'enllaç per restablir la contrasenya",
      send: 'Enviar enllaç',
      checkMail: 'Revisa el teu correu',
      accept: 'entesos',
      mailSended:
        "T'hem enviat un correu a {{ email }} perquè puguis reiniciar la contrasenya",
    },
    bkgSignUpDialog: {
      access: 'Accedeix',
      bodyTitle:
        "Registra't per reservar més ràpid i acumular punts que podràs canviar per descomptes.",
      cancel: 'Cancel·lar',
      promoEmails:
        "Accepto rebre comunicacions de novetats, promocions i descomptes d'aparca&go.",
      newsletterEmails: "Accepto subscriure'm a la newsletter.",
      continueBtn: 'Continua sense registrar-me',
      createError: 'Hi ha un error! Revisa les dades i torna a intentar-ho',
      email: 'Email',
      haveAccount: 'Ja tens un compte?',
      name: 'Nom',
      password: 'Contrasenya',
      privacyPolicy:
        'He llegit i entenc la <a href="/es/politica-privacidad">Política de privacitat</a>',
      signUpFree: "Registra't gratis",
      signUpWithFb: 'Facebook',
      signUpWithGoogle: 'Google',
      signUpWithApple: 'Apple',
      surname: 'Cognoms',
      title: "Registra't gratis",
    },
    bkgSummary: {
      acceptPromos:
        "Accepto rebre comunicacions de novetats, promocions i descomptes d'aparca&go.",
      acceptNewsletter: "Accepto subscriure'm a la newsletter.",
      acceptTerms:
        'Estic d\'acord amb la <a href="/ca/politica-privadesa" target="_blank" title="Política de privadesa"><strong>Política de privadesa</strong></a> i les <a href="/ca/avis-legal" title="Condicions d\'ús d\'aparca&go" target="_blank"><strong>condicions d\'ús</strong></a>',
      book: 'Reservar',
      carInsuranceTerms:
        "Declaro que el vehicle està cobert per l'assegurança obligatòria de l'automòbil i la corresponent autorització administrativa per circular.",
      carServiceTerms:
        'Autoritzo a aparca&go i als seus tallers associats a circular amb el meu vehicle durant el mínim temps necessari per realitzar els serveis contractats.',
      continue: 'Continuar',
      needServices: 'Necessites seleccionar almenys un servei per continuar',
      disabledTerms: 'Accepta les condicions de contractació.',
      disabledBookingForm: 'Revisa les dades de la reserva.',
      disabledBillingForm: 'Revisa les dades de facturació.',
      estimateAccept: '* Al reservar estàs acceptant el pressupost',
      reservationNumber: 'Número de reserva',
      return: 'Tornar',
      termsAccepted:
        'A l\'reservar estàs acceptant els <a href="/es/politica-privacidad" target="_blank" title="Política de privacidad"><strong>termes</strong></a> i <a href="/es/aviso-legal" title="Condiciones de uso aparca&go" target="_blank"><strong>condicions d\'ús</strong></a> d\'aparca & go',
    },
    bkgSummaryDiscounts: {
      availablePoints: 'Els teus euros acumulats disponibles:',
      discount: 'Descompte:',
      havePromoCode: 'Tens un codi promocional?',
      insertCode: 'Introdueix el teu codi',
      pointsApplied: '¡{{ points }} euros aplicats correctament!',
      promoFailed: 'Codi no vàlid',
      promoSuccess: "El teu codi promocional s'ha aplicat correctament!",
      redeem: 'Descanviar',
      validate: 'Validar',
      wantUsePoints: 'Vols fer servir els teus euros acumulats?',
    },
    bkgSummaryLocation: {
      location: 'Ubicació del pàrquing',
      premiumLocation: "Punt d'entrega",
      locationDescription: "Consulta la localització de l'aparcament al mapa.",
      openMap: 'obrir mapa',
      parkingLocation: 'Ubicació del pàrquing',
      howToGet: 'Com arribar',
    },
    bkgSummaryPrice: {
      carServiceDiscount: 'Descompte Car Service',
      customService: 'Servei Personalitzat',
      customTiresService: 'Canvi de pneumàtics',
      free: 'Gratis',
      freeCancellation: 'Cancel·la gratis',
      payInParking: 'Paga al pàrquing',
      place: 'Plaça',
      doubleSpace: 'Plaça Doble',
      points: 'Punts aparca&go',
      price: 'Serveis i preu',
      promo: 'Promo',
      total: 'TOTAL',
      wash: 'Rentat',
      totalWithoutPromo: 'TOTAL SENSE PROMO',
      removal: 'Trasllat',
      taxesSentence2:
        '(*) Taxes oficials segons tipus emissió de vehicle: 40,60€ gasolina, 45,59€ dièsel, 54,98€ furgoneta dièsel industrial...)',
      taxesSentence3: '(*) Taxes oficials segons tipus emissió de vehicle',
      carDiscountTitle: 'Descomptes de la promo Car Service',
      carDiscountBody:
        "Heu seleccionat serveis per valor de {{total}}€ pel que et correspon un {{discount}}% de descompte en el cost del teu Pàrquing.<br><br>Taula de descomptes en el pàrquing a l'afegir serveis de Car Service:<br><br>25% en el Pàrquing partir de 99€ en Car Service<br>50% en el Pàrquing partir d'199€ a Car Service<br>75% en el Pàrquing partir d'299€ a Car Service<br>¡Aparcament Gratuït fins a 40€ a partir de 499€ en Car Service!",
      carFerryBody:
        "En reserves amb serveis de Car Service de menys de 200 € afegim el cost de l'trasllat de el vehicle fins al taller. Afegeix més serveis per eliminar el cost de l'trasllat.",
    },
    bkgSummaryReservation: {
      checkIn: 'Entrada:',
      checkOut: 'Sortida:',
      checkInPremium: 'Lliurament:',
      checkOutPremium: 'Recollida:',
      diffTimeZone: "Hora d'Espanya",
      data: 'Dades',
      email: 'Email:',
      flightNumber: 'Núm. Vol de tornada:',
      modify: 'Canviar',
      name: 'Nom:',
      plate: 'Matrícula:',
      terminal: 'Terminal:',
      outTerminal: 'Terminal de tornada:',
      yourReservation: 'Informació de la reserva',
      billingProfile: 'Perfil de facturació:',
    },
    bkgSummaryServices: {
      detail: 'Detalls',
      modify: 'Canviar',
      remove: 'Treure',
      services: 'Serveis',
    },
    bkgSummaryVehicle: {
      modify: 'Canviar',
      edit: 'Editar',
      yourVehicle: 'El teu vehicle',
    },
    bkgVehicleDialog: {
      addVehicle: 'Afegir vehicle',
      editVehicle: 'Editar vehicle',
      selectVehicleTitle: 'Seleccionar vehicle',
    },
    bkgVehicleDialogSelectClientCar: {
      addNewVehicle: 'Afegeix un nou vehicle',
      agree: 'Acceptar',
      selectVehicle: 'Seleccionar vehicle',
      selectVehicleSubtitle: 'Tria amb quin vehicle arribaràs',
    },
    bkgVehicleDialogCompleteCarDataForm: {
      agree: 'Acceptar',
      body: 'Carrosseria',
      completeVehicleInfo:
        'Necessitem més dades del teu vehicle per donar-te el preu exacte del teu servei',
      kilometers: 'Quilòmetres',
      motor: 'Motor',
      selectBody: 'Seleccionar carrosseria',
      selectMotor: 'Seleccionar motor',
    },
    bkgVehicleDialogLicensePlate: {
      agree: 'Aceptar',
      forgottenCarLicensePlate: 'No recordo la matrícula',
      insertCarLicensePlate: '¿Quina és la matrícula del teu cotxe?',
      placeholderPlate: '0000 ABC',
    },
    bkgVehicleDialogUmcSelectors: {
      addMakeModelSubtitle: 'Utilitza marca o model del vehicle',
      agree: 'Acceptar',
      make: 'Marca:',
      model: 'Model:',
      notFoundCarOption: 'No trobo el meu cotxe',
      propulsion: 'Propulsió:',
      selectMake: 'Selecciona Marca',
      selectModel: 'Selecciona Model',
      selectPropulsion: 'Selecciona Propulsió',
      fromToCurrent: "a partir d'l'any {{ from }}",
      fromToYear: 'entre el {{ from }} i el {{to}}',
      year: 'Any de fabricació',
    },
    bkgVehicleDialogNotFoundForm: {
      email: 'Email',
      color: 'Color',
      make: 'Marca',
      model: 'Model',
      send: 'Enviar',
      text:
        "Indica'ns la marca i model del teu cotxe i ens posarem en contacte amb tu per donar-te el pressupost.",
    },
    bkgVehicleWarningDialog: {
      title: 'Atenció!',
      text1:
        "Al realitzar aquesta acció s'eliminarà el vehicle seleccionat i els serveis mecànics prèviament afegits.",
      text2: 'Canviar de vehicle?',
      textModifyKm:
        "En finalitzar aquesta acció s'eliminaran els serveis mecànics prèviament afegits.",
      textModifyWorkshop:
        "En finalitzar aquesta acció s'eliminaran els serveis mecànics prèviament afegits.",
      accept: 'Acceptar',
      cancel: 'Cancel·lar',
    },
    bkgLinkReservationDialog: {
      title: 'Importar reserva',
      loginText: 'Accedeix per importar reserva',
      linkReservationText:
        'El teu compte disposa de múltiples configuracions. Confirma quina prefereixes utilitzar en la teva reserva',
      linkReservationTextWithoutConfigurations:
        'Confirma que vols desar aquesta reserva en aquest compte',
      forgetPassword: 'Recuperar contrasenya',
      password: 'Contrasenya',
      vehicle: 'Vehicle',
      profile: 'Dades de facturació',
      saveBtn: 'Desar',
      importBtn: 'Importar',
      login: 'Accedir',
      profileCheckbox: 'No vincular dades de facturació',
      importVehicle: 'Vincular vehicle actual',
    },
    bkgChangeUserModeDialog: {
      titleChangeBusiness: "Vols canviar al teu perfil d'empresa?",
      titleChangeParticular: 'Vols canviar al teu perfil particular?',
      bodyChangeBusiness:
        "Estàs reservant un usuari en concret. Si vols fer una reserva d'empresa amb factura, clica a 'canviar a perfil d'empresa'. ",
      bodyChangeParticular:
        "Estàs reservant com a usuari d'empresa. Si vols fer una reserva particular sense factura, clica a 'canviar a perfil particular'. ",
      btnChangeBusiness: "Canviar a perfil d'empresa",
      btnChangeParticular: 'Canviar a perfil particular',
      btnStayAsParticular: 'Seguir reservant com a usuari particular',
      btnStayAsBusiness: "Seguir reservant com a usuari d'empresa",
    },
    bkgSummaryVouchers: {
      title: "Bescanvia els teus cupons!",
      discount_percent: "{{value}}% de descompte",
      discount_euro: "{{value}}€ de descompte",
      expires_on: "Caduca el <br> {{date}}",
    },
    bkgVoucherBanner: {
      title_singular: "Tens 1 cupó disponible!",
      title_plural: "Tens {{count}} cupons disponibles!",
      body: "Bescanvia els teus cupons!"
    }
  },
  servicesStep: {
    title: "Aprofita l'ocasió per posar a punt el teu cotxe",
    bkgExtraServices: {
      add: 'Afegir +',
      availableServicesFrom:
        '{{ extrasLength }} programes disponibles en {{ cheaperServiceUnitaryPrice }}€',
      desinfection: 'Rentats amb desinfecció',
      remove: 'Treure',
      washes: 'Rentats i desinfeccions',
      blockWashes: 'Servei bloquejat per la teva empresa',
    },
    bkgCarServices: {
      add: 'Afegir +',
      calculatePrice: 'Calcular preu',
      freeReservation: 'La teva reserva et pot sortir gratis!',
      notAvailable: 'Actualment no disponible',
      remove: 'Treure -',
      detail: 'Veure detall +',
      workshopText:
        'Escull si vols contractar un servei amb un taller aparca&go o amb un concessionari oficial.',
      agoWorkshop: 'Tallers aparca&go',
      officialWorkshop: 'Concessionari oficial',
      needFees: '+ taxes',
      availabilityHighDemand: 'Poques places disponibles',
      availabilityAlmostOut: 'Gairebé esgotat',
      availabilityOutOfStock: 'Esgotat',
    },
    bkgCarServicesB: {
      title: 'Car Service',
      minPriceWarranty: 'Preu mínim garantitzat',
    },
    bkgAdditionalCarServices: {
      title: 'Serveis suplementaris',
    },
  },
  travelerStep: {
    billingForm: {
      addProfile: 'Afegir perfil',
      companyAddress: 'Direcció',
      companyCity: 'Població',
      companyEmail: 'E-mail de facturació',
      companyName: 'Raó fiscal / Nom i cognoms',
      companyState: 'Província',
      companyVat: 'CIF / NIF',
      companyZip: 'Codi postal',
      companyCountry: 'Pais',
      createProfile: 'Crea un perfil de facturació',
      editProfile: 'Modificar perfil',
      editProfileTitle: 'Modificar perfil de facturació',
      needInvoiceData:
        'Per requeriment legal tots els serveis de taller requereixen factura.',
      newProfileBody:
        'Crea un perfil de facturació per guardar les teves dades i no haver de repetir-los cada vegada que reserves.',
      newProfileTitle: 'Nou perfil de facturació',
      profile: 'Perfil',
      title: 'Dades de facturació',
      preventEditCorporateProfile: 'Accedeix a la teva àrea personal per modificar un perfil corporatiu',
    },
    invoiceProfileDialog: {
      accept: 'Acceptar',
      companyAddress: 'Direcció',
      companyCity: 'Població',
      companyEmail: 'E-mail de facturació',
      companyName: 'Raó fiscal / Nom i cognoms',
      companyState: 'Província',
      companyVat: 'CIF / NIF',
      companyZip: 'Codi postal',
      companyCountry: 'Pais',
      invoicingMethod: 'Mètode de facturació',
      monthly: 'Mensual',
      saveAsDefaultProfile: 'Desa perfil per defecte',
      service: 'Per servei',
      nifError: 'El NIF introduït no és un DNI, insereix nom i cognoms',
      nieError: 'El NIF introduït no és un NIE, insereix nom i cognoms',
    },
    reservationForm: {
      addVehicle: 'Afegir vehicle',
      editVehicle: 'Edita vehicle',
      email: 'Email',
      name: 'Nom',
      needInvoice: 'Necessito factura',
      optional: '(Opcional)',
      phone: 'Telèfon',
      record: 'nom. expedient',
      recordCompany: 'Referència viatge',
      signPlate: 'Matrícula',
      surname: 'Cognoms',
      title: 'Dades de la reserva',
      travelForWork: 'Viatjo per feina',
      travelForWorkTooltip:
        "¿Viatges per treball? Canvia al teu perfil d'empresa.",
      paymethod: 'Mètode de pagament',
      paymethodComment: 'No et cobrem ara, és per accelerar la teva sortida.',
      vehicle: 'Vehicle',
      notes: 'Comentari sobre la reserva (opcional)',
      indicateAtExit: 'Indicar a la sortida.',
      employees: 'Empleats',
      employeesTooltip:
        'Selecciona el treballador per a qui reserves el pàrquing',
      yourData: 'Les teves dades',
      modify: 'Modificar',
    },
  },

};
